import React from 'react';
import PropTypes from 'prop-types';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  questionBox: {
    padding: theme.spacing(2),
    textAlign: 'center',
  },
}));

function QuestionHeaderBox({ color, children }) {
  const classes = useStyles();
  return (
    <Box border={2} style={{ borderColor: color }} borderRadius={8} className={classes.questionBox}>
      {children}
    </Box>
  );
}

QuestionHeaderBox.propTypes = {
  color: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node), // as you can render an array of elements
    PropTypes.element, // for a single component/element
  ]).isRequired,
};

export default QuestionHeaderBox;
